import { Box, Typography } from '@mui/material';

import { styles } from '../styles';
import { TextCol } from './HeaderCol';

export const DataCol = ({
  type,
  value,
  addition = null,
  status = null,
  isLast,
  showLeadingLines,
}) => {
  if (type === 'text' || type === 'date') {
    return <TextCol value={value} type={type} />;
  }

  if (type === 'title') {
    return (
      <Box
        sx={
          showLeadingLines
            ? {
                ...styles.block(status),
                ...(isLast ? styles.blockEnd(status) : {}),
              }
            : {}
        }
      >
        <Typography component="span">{value}</Typography>
        {addition}
      </Box>
    );
  }

  if (type === 'custom') {
    return value;
  }
};
